export default "__VITE_ASSET__Z9ID34QL__";